module.exports = __webpack_public_path__ + "static/media/intro.483969b2.mp3";